<template>
  <div class="home">
    <div class="home__header">
      <h2>PŘIPRAVTE SE NA OCR ZÁVODY KOMPLEXNĚ. <br />STAČÍ SI JEN VYBRAT!</h2>

      <div class="my-row">
        <!-- ✅ SKELETON pro kategorie -->
        <template v-if="categoriesAreLoading">
          <div
            v-for="n in categorySkeletonCount"
            :key="'cat-skel-' + n"
            class="col-12-xs col-6-md col-3-xl"
          >
            <div class="category_wrapper category-skeleton placeholder-glow">
              <div class="category-skeleton__img placeholder"></div>

              <div class="category-skeleton__title placeholder"></div>

              <ul class="category-skeleton__list">
                <li v-for="i in 5" :key="'cat-skel-li-' + n + '-' + i">
                  <span class="category-skeleton__line placeholder"></span>
                </li>
              </ul>

              <div class="category-skeleton__btn placeholder"></div>
            </div>
          </div>
        </template>

        <!-- ✅ Reálné kategorie -->
        <template v-else>
          <div
            v-for="category in categories"
            :key="category.id"
            class="col-12-xs col-6-md col-3-xl"
          >
            <div class="category_wrapper">
              <img
                :src="imageBasePath + 'categories/' + category.image_path"
                alt=""
              />
              <h3>
                <router-link
                  :to="{
                    name: 'Category',
                    params: { categoryname: category.url_path },
                  }"
                >
                  {{ category.name }}
                </router-link>
              </h3>
              <ul>
                <li v-for="child in category.children" :key="child.id">
                  <router-link
                    :to="{
                      name: 'Category',
                      params: { categoryname: child.url_path.split('/') },
                    }"
                    >{{ child.name }}
                  </router-link>
                </li>
              </ul>
              <router-link
                class="btn-gray"
                :to="{
                  name: 'Category',
                  params: { categoryname: category.url_path },
                }"
              >
                Všechny produkty
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="banners">
      <banners-images-slider
        class="xs-to-sm"
        :imageBasePath="this.imageBasePath + 'banners/'"
        :images="[
          { path: 'Banner - Výživa - mobil 576x1200.png' },
          { path: 'Banner - Regenerace - mobil 576x1200.png' },
          { path: 'Banner - OCR Vybavení - mobil 576x1200.png' },
          { path: 'Banner - Fitness Vybavení - mobil 576x1200.png' },
          { path: 'Banner - Boty - mobil 576x1200.png' },
        ]"
      />
      <banners-images-slider
        class="sm-to-md"
        :imageBasePath="this.imageBasePath + 'banners/'"
        :images="[
          { path: 'Banner - Výživa - mobil 768x1200.png' },
          { path: 'Banner - Regenerace - mobil 768x1200.png' },
          { path: 'Banner - OCR Vybavení - mobil 768x1200.png' },
          { path: 'Banner - Fitness Vybavení - mobil 768x1200.png' },
          { path: 'Banner - Boty - mobil 768x1200.png' },
        ]"
      />
      <banners-images-slider
        class="md-to-lg"
        :imageBasePath="this.imageBasePath + 'banners/'"
        :images="[
          { path: 'Banner - Výživa - tablet 1100x1200.png' },
          { path: 'Banner - Regenerace - tablet 1100x1200.png' },
          { path: 'Banner - OCR Vybavení - tablet 1100x1200.png' },
          { path: 'Banner - Fitness Vybavení - tablet 1100x1200.png' },
          { path: 'Banner - Boty - tablet 1100x1200.png' },
        ]"
      />
      <banners-images-slider
        class="lg-to-xl"
        :imageBasePath="this.imageBasePath + 'banners/'"
        :images="[
          { path: 'Banner - Výživa - desktop n. 2 1200x650.png' },
          { path: 'Banner - Regenerace - desktop 1200x650.png' },
          { path: 'Banner - OCR Vybavení - desktop n. 2 1200x650.png' },
          { path: 'Banner - Fitness Vybavení - desktop 1200x650.png' },
          { path: 'Banner - Boty - desktop 1200x650.png' },
        ]"
      />
      <banners-images-slider
        class="xl-to-"
        :imageBasePath="this.imageBasePath + 'banners/'"
        :images="[
          { path: 'Banner - Výživa - desktop 1920x750.png' },
          { path: 'Banner - Regenerace - desktop 1920x750.png' },
          { path: 'Banner - OCR Vybavení- desktop 1920x750.png' },
          { path: 'Banner - Fitness Vybavení - desktop 1920x750.png' },
          { path: 'Banner - Boty - desktop 1920x750.png' },
        ]"
      />
    </div>

    <div class="home__trailer">
      <div class="my-row">
        <div class="col-12-xs col-6-md col-3-xl">
          <img src="../../public/assets/showRoom/prvni.jpg" alt="" />
          <div class="img_text_wrapper">
            <img src="../../public/assets/icons/quality.svg" alt="" />
            <span>KVALITA ZBOŽÍ</span>
          </div>
        </div>
        <div class="col-12-xs col-6-md col-3-xl">
          <img src="../../public/assets/showRoom/druhy.jpg" alt="" />
          <div class="img_text_wrapper">
            <img src="../../public/assets/icons/equipment.svg" alt="" />
            <span>VYBAVENÍ DO GYMŮ</span>
          </div>
        </div>
        <div class="col-12-xs col-6-md col-3-xl">
          <img src="../../public/assets/showRoom/treti.jpg" alt="" />
          <div class="img_text_wrapper">
            <img src="../../public/assets/icons/one_place.svg" alt="" />
            <span>VŠE NA JEDNOM MÍSTĚ</span>
          </div>
        </div>
        <div class="col-12-xs col-6-md col-3-xl">
          <img src="../../public/assets/showRoom/ctvrty.jpg" alt="" />
          <div class="img_text_wrapper">
            <img src="../../public/assets/icons/ocr.svg" alt="" />
            <span>SPECIALISTA NA OCR ZÁVODY!</span>
          </div>
        </div>
      </div>
    </div>

    <div class="home__eshop my-row">
      <h3 class="col-12-xs">E-SHOP</h3>

      <!-- ✅ Skeleton grid (jen při prvním loadu) -->
      <div
        v-if="wholeProductsAreLoading"
        class="home__eshop__wrapper my-row col-12-xs"
      >
        <ProductSkeleton
          v-for="n in skeletonCount"
          :key="'sk-home-' + n"
          sizes="col-6-xs col-4-lg col-3-xl"
        />
      </div>

      <!-- ✅ Produkty -->
      <div v-else class="home__eshop__wrapper my-row col-12-xs">
        <Product
          v-for="product in products"
          :key="product.id"
          sizes="col-6-xs col-4-lg col-3-xl"
          :products="product"
        />
      </div>

      <button
        v-if="this.pagination.current_page < this.pagination.last_page"
        class="btn-gray"
        :onClick="() => getProducts()"
      >
        <VaProgressCircle v-show="this.isLoading" indeterminate />
        <span v-show="!this.isLoading">Zobrazit další produkty</span>
      </button>
    </div>

    <div class="banners my-row home__eshop">
      <h3 class="col-12-xs">NAŠI AMBASADOŘI</h3>
      <banners-images-slider
        class="xs-to-md"
        :breakpoints="{
          '(min-width: 1px)': { slides: { perView: 1.1, spacing: 5 } },
          '(min-width: 576px)': { slides: { perView: 2.1, spacing: 10 } },
          '(min-width: 768px)': { slides: { perView: 2.1, spacing: 10 } },
        }"
        :imageBasePath="this.imageBasePath + 'ambassadors/'"
        :images="[
          { path: 'Banner Adam volák - Mobil.png' },
          { path: 'Banner Josef Drbohlav - mobil.png' },
          { path: 'Banner Klára Lokajíčková - Mobil.png' },
          { path: 'Banner Kuba Jakoubek - mobil.png' },
          { path: 'Banner Lukáš Novák - mobil.png' },
          { path: 'Banner Patrik Stupka - Mobil.png' },
        ]"
      />
      <banners-images-slider
        class="md-to-"
        :breakpoints="{
          '(min-width: 768px)': { slides: { perView: 2.1, spacing: 10 } },
          '(min-width: 992px)': { slides: { perView: 2.1, spacing: 10 } },
          '(min-width: 1200px)': { slides: { perView: 3.1, spacing: 20 } },
          '(min-width: 1600px)': { slides: { perView: 3.1, spacing: 20 } },
          '(min-width: 1920px)': { slides: { perView: 4.1, spacing: 20 } },
        }"
        :imageBasePath="this.imageBasePath + 'ambassadors/'"
        :images="[
          { path: 'Banner Adam volák - Desktop + Tablet.png' },
          { path: 'Banner Josef Drbohlav - Desktop + Tablet.png' },
          { path: 'Banner Klára Lokajíčková - Desktop + Tablet.png' },
          { path: 'Banner Kuba Jakoubek - Desktop + Tablet.png' },
          { path: 'Banner Lukáš Novák - Desktop + Tablet.png' },
          { path: 'Banner Patrik Stupka - Desktop + Tablet.png' },
        ]"
      />
    </div>

    <CustomMade></CustomMade>
    <div class="home__reviews">
      <Slider v-if="ratings.length" :ratings="ratings"></Slider>
    </div>
  </div>
</template>

<script>
import axios from "../api";
import CustomMade from "@/components/CustomMade.vue";
import Slider from "@/components/Slider.vue";
import Product from "@/components/Product.vue";
import ProductSkeleton from "@/components/ProductSkeleton.vue";
import BannersImagesSlider from "../components/BannersImagesSlider.vue";
import "keen-slider/keen-slider.min.css";

export default {
  components: {
    CustomMade,
    Slider,
    Product,
    ProductSkeleton,
    BannersImagesSlider,
  },

  data() {
    return {
      slide: 0,
      sliding: null,
      page: 0,
      categories: [],
      ratings: [],
      products: [],
      pagination: {},
      isLoading: false,

      // ✅ skeleton - products
      wholeProductsAreLoading: false,
      skeletonCount: 8,

      // ✅ skeleton - categories
      categoriesAreLoading: true,
      categorySkeletonCount: 4,

      imageBasePath: `${process.env.VUE_APP_FITMO_BACKEND_URL}/`,
    };
  },

  methods: {
    async getCategories() {
      this.categoriesAreLoading = true;

      try {
        const response = await axios.post("/api/categories", {
          filter: [{ column: "id_parent", operator: "!=", value: null }],
        });
        this.categories = this.groupByKeyReduce(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        this.categoriesAreLoading = false;
      }
    },

    groupByKeyReduce(arr) {
      if (arr.length === 0) return;
      var map = {};
      var array = arr;
      for (var i = 0; i < array.length; i++) {
        var obj = array[i];
        obj.children = [];

        map[obj.id] = obj;

        var parent = obj.id_parent || "-";
        if (!map[parent]) {
          map[parent] = {
            children: [],
          };
        }
        map[parent].children.push(obj);
      }

      return map["-"].children;
    },

    async getRatings() {
      try {
        const response = await axios.get("/api/ratings");
        this.ratings = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getProducts() {
      this.isLoading = true;

      // ✅ skeleton jen při prvním loadu
      if (this.products.length === 0) {
        this.wholeProductsAreLoading = true;
      }

      try {
        const url = this.pagination.next_page_url ?? "/api/products";
        const response = await axios.get(url);
        this.products = [...this.products, ...response.data.data];
        this.pagination = response.data.pagination;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
        this.wholeProductsAreLoading = false;
      }
    },
  },

  mounted() {
    this.getCategories();
    this.getRatings();
    this.getProducts();
  },
};
</script>

<style lang="scss">
.Home {
  max-height: none;
}

.home {
  background: $gray-third;

  &__header {
    max-width: 1140px;
    width: 90%;
    margin: auto;
    padding-top: 3.4rem;

    &__showroom {
      height: 50rem;
      border: 1px solid black;
      margin: 7rem 0;

      img {
        object-fit: cover;
      }
    }

    h2 {
      font-size: 3rem;
    }

    .my-row {
      display: flex;
      margin-top: 5rem;

      > div {
        display: flex;
        justify-content: center;
        padding: 1rem;
        margin: 0;

        .category_wrapper {
          background: $white;
          margin-top: 7rem;
          display: flex;
          border-radius: 2rem;
          flex-direction: column;
          padding: 3rem 0 0 3rem;
          position: relative;
          max-width: 30rem;
          transition: 0.3s ease all;

          &:hover {
            box-shadow: 2px 3px 18px rgba(0, 0, 0, 0.07);
          }

          img {
            max-width: 22rem;
            aspect-ratio: 220/180;
            object-fit: contain;
            position: absolute;
            top: 0;
            left: calc(50% - 11rem);
            transform: translateY(-45%);
          }

          h3 {
            max-width: 60%;
            text-align: left;
            margin-top: 7rem;
            margin-bottom: 1.5rem;
            font-weight: 700;
            text-transform: uppercase;
            height: 6rem;
            display: flex;
            align-items: flex-end;
          }

          ul {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 3rem;
            overflow: hidden;
            max-height: 7.8rem;

            li {
              padding-right: 0.9rem;
              position: relative;

              a {
                position: relative;

                &::before {
                  content: "";
                  display: block;
                  position: absolute;
                  bottom: 2px;
                  left: 0%;
                  transition: 0.2s ease width;
                  height: 1px;
                  background: $gray-second;
                  width: 0%;
                }

                &:hover {
                  &::before {
                    width: 100%;
                  }
                }
              }

              &::after {
                content: "";
                width: 1px;
                height: 65%;
                background: $gray-second;
                display: block;
                position: absolute;
                top: 17.5%;
                left: -0.5rem;
              }
            }
          }

          & > a {
            width: 18rem;
            margin: auto 0 2rem 0;
          }
        }

        /* ============================
           ✅ Skeleton 1:1 s kategoriemi
           ============================ */

        /* Skeleton wrapper musí mít stejné paddingy i layout jako reálná karta */
        .category_wrapper.category-skeleton {
          padding: 3rem 0 0 3rem; /* stejné jako .category_wrapper */
          max-width: 30rem;
          position: relative;
          display: flex;
          flex-direction: column;
        }

        /* Skeleton image musí být absolutní stejně jako reálný img */
        .category-skeleton__img {
          width: 22rem;
          height: calc(22rem * 180 / 220); /* 18rem poměrově 220/180 */
          border-radius: 2rem;

          position: absolute;
          top: 0;
          left: calc(50% - 11rem);
          transform: translateY(-45%);

          /* ať to nevylejzá mimo wrapper */
          overflow: hidden;
        }

        /* Skeleton title musí sedět na místo h3 */
        .category-skeleton__title {
          width: 60%;
          height: 22px;
          border-radius: 12px;

          margin-top: 9rem; /* stejné jako h3 */
          margin-bottom: 1.5rem; /* stejné jako h3 */
        }

        /* Skeleton list musí kopírovat reálné ul */
        .category-skeleton__list {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 3rem;
          overflow: hidden;
          max-height: 7.8rem;

          padding-left: 0;
          list-style: none;

          li {
            padding-right: 0.9rem;
            position: relative;

            /* napodobí ten "oddělovač" v reálném listu */
            &::after {
              content: "";
              width: 1px;
              height: 65%;
              background: $gray-second;
              display: block;
              position: absolute;
              top: 17.5%;
              left: -0.5rem;
            }
          }
        }

        /* Skeleton "řádky" v listu – podobná šířka jako linky */
        .category-skeleton__line {
          display: inline-block;
          width: 7.5rem; /* aby to vypadalo jako krátké názvy kategorií */
          height: 14px;
          border-radius: 10px;
        }

        /* Skeleton button musí sedět na místo reálného router-link tlačítka */
        .category-skeleton__btn {
          width: 18rem;
          height: 38px;
          border-radius: 12px;

          margin: auto 0 2rem 0; /* stejné jako & > a v reálné kartě */
        }
      }
    }
  }

  &__banner {
    img {
      width: 100%;
    }

    margin: 4rem 0 4.5rem 0;
  }

  &__trailer {
    color: $white;
    font-weight: 400;
    font-size: 1.8rem;
    position: relative;

    .my-row > div {
      position: relative;

      > img {
        padding: 1rem;
        border-radius: 2.5rem;
        object-fit: cover;
        min-height: 100%;
      }

      .img_text_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        img {
          height: 11rem;
          filter: drop-shadow(2px 4px 16px black);
        }

        span {
          font-weight: 700;
          font-size: 1.6rem;
          filter: drop-shadow(2px 4px 16px black);
        }
      }
    }
  }

  &__eshop {
    margin: auto;
    justify-content: space-between;
    padding: 0 5%;
    margin-bottom: 4rem;

    .btn-gray {
      color: #525358;
      padding: 1rem 2rem;
      border-radius: 0 0 2rem 2rem;
      border: none;
      font-size: 12px;
      text-decoration: underline;
    }

    & > img {
      margin: 6rem 0 20rem 0;
    }

    h3 {
      font-size: 3.2rem;
      margin: 13.4rem 0 4rem 0;
    }

    &__wrapper {
      background: $white;
      border-radius: 2rem;
      position: relative;
      padding-bottom: 2rem;

      &::before {
        content: "";
        top: 0;
        left: 2rem;
        width: calc(100% - 4rem);
        height: 1px;
        background: white;
        position: absolute;
        z-index: 2;
      }

      &::after {
        content: "";
        right: 0;
        top: 2rem;
        height: calc(100% - 4rem);
        width: 1px;
        background: white;
        position: absolute;
        z-index: 2;
      }

      &__img_wrapper {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        overflow: hidden;

        &__subProducts {
          display: flex;
          border-radius: 50%;
          margin-bottom: 0.4rem;
          height: 2.2rem;
          width: 2.2rem;
          border: 2px solid $gray-second;
          overflow: hidden;
          flex-direction: row;

          &__wrapper {
            height: 2.5rem;
            margin-bottom: 0.2rem;
          }

          &.active {
            border-color: $black-headers;
            border-width: 3px;
          }

          & > div {
            display: block;
            height: 2.2rem;
            width: 2.2rem;
          }
        }

        img {
          transition: 0.3s ease all;
          width: 100%;
          height: 100%;
          margin: 0 auto;
        }

        img:nth-of-type(2) {
          position: absolute;
          top: 0;
          opacity: 0;
        }
      }

      &__item_discount {
        position: absolute;
        background: #fdc300;
        color: #ffffff;
        border-radius: 50%;
        font-size: 1.1em;
        font-weight: 400;
        height: 5rem;
        width: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 2rem;
        top: 2rem;
        z-index: 7;
      }

      & > div {
        position: relative;
        text-align: center;
        display: flex;
        flex-direction: column;
        transition: 0.4s ease all;
        border-radius: 2rem;
        overflow: hidden;
        padding-bottom: 2rem;

        h4 {
          line-height: 1.7rem;
          font-size: 1.44rem;
          max-width: 80%;
          margin: auto;
        }

        img {
          margin: 0 auto;
          object-fit: contain;
          height: 25rem;
          max-height: 25rem;
        }

        &::before {
          content: "";
          position: absolute;
          width: 80%;
          height: 1px;
          background: $gray-fourth;
          top: 0;
          left: 10%;
        }

        &:nth-child(odd) {
          &::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 80%;
            background: $gray-fourth;
            right: 0;
            top: 10%;
          }
        }
      }

      &__name {
        font-size: 1.2rem;
        line-height: 2.8rem;
        min-height: 1.8rem;
      }

      &__price {
        font-weight: 700;
        font-size: 1.6rem;
        margin-top: 1.3rem;
        display: flex;
        justify-content: center;
        align-items: center;

        & > * {
          margin: 0 0.2rem;
        }

        &__trough {
          font-size: 1.1rem;
          font-weight: 400;
          position: relative;

          &::after {
            content: "";
            top: calc(50% - 1px);
            left: 0%;
            background: $black-headers;
            height: 2px;
            width: 100%;
            position: absolute;
          }
        }

        &__discount {
          color: $yellow;
        }
      }

      &__discounts {
        margin-top: 0.4rem;
        min-height: 2.8rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        span {
          font-size: 1rem;
          padding: 0.3rem 0.7rem;
          line-height: 1.3rem;
          margin: 0.2rem;
        }
      }
    }
  }

  &__gray_banner {
    height: 73.8rem;
    background: $black-second;
    width: 100%;
    display: block;
  }
}

@media screen and (min-width: $screen-sm-min) {
  .home__eshop {
    .btn-gray {
      padding: 1.5rem 4rem;
      font-size: 15px;
    }

    &__wrapper {
      & > div {
        h4 {
          font-size: 2.2rem;
          line-height: 2.3rem;
          color: $black-headers;
        }
      }

      &__item_discount {
        height: 6.5rem;
        width: 6.5rem;
        font-size: 2rem;
      }

      &__name {
        font-size: 1.63rem;
        margin-top: 0.3rem;
      }

      &__price {
        font-size: 1.9rem;
        color: $black-second;

        &__trough {
          font-size: 1.4rem;
          font-weight: 400;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-md-min) {
  .home {
    &__header {
      padding-top: 11.1rem;
    }

    &__trailer {
      .center {
        display: block;
      }

      .my-row > div .img_text_wrapper span {
        font-size: 1.8rem;
      }
    }

    &__eshop__wrapper {
      &__item_discount {
        top: 3rem;
        right: 3rem;
      }

      &__discounts {
        span {
          font-size: 1.2rem;
          padding: 0.7rem 1.3rem;
          line-height: 1.3rem;
          margin: 0.2rem;
          font-weight: 400;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-md-min) and (max-width: ($screen-xl-min - 1px)) {
  .home__header .my-row > div {
    &:nth-child(odd) {
      justify-content: flex-end;
    }

    &:nth-child(even) {
      justify-content: flex-start;
    }
  }
}

@media screen and (min-width: $screen-lg-min) {
  .home {
    &__trailer .my-row > div {
      > img {
        padding-left: 1rem;
      }

      .img_text_wrapper {
        span {
          font-size: 2rem;
        }

        img {
          height: 12rem;
        }
      }
    }

    &__eshop {
      &__wrapper {
        padding: 0;

        & > div {
          &:hover {
            -webkit-box-shadow: 2px 3px 18px rgba(0, 0, 0, 0.29);
            -moz-box-shadow: 2px 3px 18px rgba(0, 0, 0, 0.29);
            box-shadow: 2px 3px 18px rgba(0, 0, 0, 0.29);
            z-index: 99;

            .home__eshop__wrapper__img_wrapper {
              img:first-of-type {
                opacity: 0;
              }

              img:last-of-type {
                opacity: 1;
              }
            }
          }

          &:nth-child(n + 7) {
            display: flex;
          }

          &::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 80%;
            background: $gray-fourth;
            right: 0;
            top: 10%;
          }
        }
      }
    }
  }
}

@media screen and (min-width: $screen-xl-min) {
  .home {
    &__eshop {
    }

    &__trailer .my-row > div {
      min-height: 28rem;

      > img {
        padding-left: 1rem;
      }

      &:last-of-type {
        padding-right: 1rem;
      }

      &:first-of-type {
        padding-left: 1rem;
      }

      .img_text_wrapper {
        img {
          height: 11rem;
        }

        span {
          font-size: 1.9rem;
          text-align: center;
          width: 85%;
        }
      }
    }

    &__header {
      //padding-top: 18.3rem;
      max-width: 1484px;

      h2 {
        font-size: 3.96rem;
        line-height: 4.3rem;
      }

      .my-row > div {
        padding: 1.6rem;

        .category_wrapper {
          max-width: unset;

          h3 {
            font-size: 2.88rem;
            margin-bottom: 2.2rem;
          }

          ul {
            font-size: 1.44rem;
            margin-bottom: 4.5rem;
          }

          > a {
            font-size: 1.44rem;
            white-space: nowrap;
            margin-bottom: 2.5rem;
          }
        }
      }
    }
  }
}

@media screen and (min-width: $screen-xxl-min) {
  .home {
    &__trailer .my-row > div {
      .img_text_wrapper {
        span {
          font-size: 2.2rem;
        }

        img {
          height: 12rem;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-sm-min) {
  .home {
    &__trailer .my-row > div {
      .img_text_wrapper {
        span {
          font-size: 2.2rem;
        }

        img {
          height: 12rem;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-md-min) {
  .home {
    &__trailer .my-row > div {
      .img_text_wrapper {
        span {
          font-size: 2rem;
        }

        img {
          height: 11rem;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-fullHd-min) {
  .home {
    &__trailer .my-row > div {
      .img_text_wrapper {
        span {
          font-size: 2.4rem;
        }

        img {
          height: 13rem;
        }
      }
    }
  }
}

.banners {
  margin: 5rem 0 1rem 0;
  padding: 0 1rem;

  h3 {
    margin: 2rem 0 4rem 0;
  }

  > div {
    display: none !important;
  }

  img {
    display: none;
    margin: auto;
    border-radius: 2.5rem;
  }

  @media screen and (min-width: $screen-xl-min) {
    padding: 0 2rem;
  }
}
</style>
